import { useRef, useState } from 'react'

export const NavigationSearch = ({ searchUrl }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef()

  const showSearch = () => {
    document.querySelector('header').classList.add('search-is-open')
    setOpen(true)
  }

  const submitSearch = () => ref.current.submit()

  if (open) {
    return <form action={searchUrl} method='POST' ref={ref}>
      <input
        className='form-control'
        autoFocus
        name='query'
        placeholder={I18n.t('layouts.header.search_placeholder')} />

      <i className="fa fa-search header-search-icon" onClick={submitSearch}></i>
    </form>
  } else {
    return <i className="header-search-icon fa fa-search" onClick={showSearch}></i>
  }
}
